export default "{\n    \"label\": \"Escalación\",\n    \"options\": {\n        \"true\": \"Actualmente escalado\"\n    }\n}\n"